/* eslint-disable react/prop-types */
import React, {useMemo, useCallback} from 'react';
import {yupResolver} from '@hookform/resolvers/yup';
import {Controller, useForm} from 'react-hook-form';
import {useDispatch, useSelector} from 'react-redux';

import {TextInput} from '../../../../../../../../../../components/common';

import {ManualTableStyles, FormContainer} from './elements';
import CustomCancel from '../../../../../../../../../../components/shared/Buttons/CustomButton';
import AddIcon from '../../../../../../../../../../assets/icons/addadmin.svg';
import {Table} from '../../../../../../../../../../components/common/Table';
import CloseIcon from '../../../../../../../../../../assets/icons/redcross.svg';
import {useErrorMessage} from '../../../../../../../../../../utils/hooks';
import {studentSchema} from '../../../../../../../../../../utils/validation';

import {
  individualStudentCheck,
  setError as setServerError,
  studentsSelector,
  clearFormError,
} from '../../../../../../../../../../redux/studentSlice';

const FIELDS_IN_ORDER = ['referId', 'firstName', 'lastName', 'email'];

export const ManualForm = ({
  manual,
  formShow,
  btnShow,
  setFormShow,
  setBtnShow,
  addStudents,
  setAddStudents,
}) => {
  const dispatch = useDispatch();
  const {error: serverError, formError} = useSelector(studentsSelector);

  const clearServerError = useCallback(() => {
    dispatch(setServerError(null));
    dispatch(clearFormError());
  }, [dispatch]);

  const {
    control,
    formState: {errors},
    setError,
    reset,
    handleSubmit,
  } = useForm({
    defaultValues: {
      referId: '',
      firstName: '',
      lastName: '',
      email: '',
    },
    resolver: yupResolver(studentSchema),
  });
  useErrorMessage(errors, serverError, clearServerError, FIELDS_IN_ORDER);

  const onSubmit = useCallback(
    data => {
      const details = {
        firstName: data.firstName,
        lastName: data.lastName,
        referID: data.referId,
        useremail: data.email,
      };
      dispatch(
        individualStudentCheck(details, validate => {
          if (validate === '') {
            const arraysOfUserEmail = addStudents.map(admin => admin.useremail);
            const arraysOfRefId = addStudents.map(admin => admin.referID);
            if (
              !arraysOfUserEmail.includes(data.email) &&
              !arraysOfRefId.includes(data.referId)
            ) {
              setAddStudents(state => [
                ...state,
                {
                  firstName: data.firstName,
                  lastName: data.lastName,
                  referID: data.referId,
                  useremail: data.email,
                },
              ]);

              setFormShow(false);
              setBtnShow(false);
            } else {
              if (arraysOfUserEmail.includes(data.email)) {
                setError('email', {
                  type: 'focus',
                  message: 'This Email Already added in this list',
                });
              }
              if (arraysOfRefId.includes(data.referId)) {
                setError('referId', {
                  type: 'focus',
                  message: 'This Reference id already added in this list',
                });
              }
            }
          }
        }),
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [addStudents],
  );

  const removeItems = position => {
    setAddStudents(state =>
      state.filter((item, index) => index !== position.index),
    );
  };
  // Manual flow mapping
  const manualcolumns = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'serial',
        className: 'serial',
      },
      {
        Header: 'ID',
        accessor: 'referID',
        className: 'ref-id-manual',
      },
      {
        Header: 'First Name',
        accessor: 'firstName',
        className: 'first-name-manual',
      },
      {
        Header: 'Last Name',
        accessor: 'lastName',
        className: 'last-name-manual',
      },
      {
        Header: 'EMAIL',
        accessor: 'useremail',
        className: 'email-manual',
      },
      {
        Header: ' ',
        Cell: ({row: position}) => (
          <button
            type="button"
            onClick={() => {
              removeItems(position);
            }}
            className="closeIconBtn"
          >
            <img src={CloseIcon} alt="close" />
          </button>
        ),
        accessor: 'addStudents',
        className: 'close-row',
      },
    ],

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  // Add a serial number to each row and memoize the data.
  const manualdata = useMemo(
    () => [
      ...addStudents.map((item, index) => ({
        ...item,
        serial: index + 1,
      })),
    ],
    [addStudents],
  );

  return (
    <FormContainer>
      <div>
        {manual && addStudents?.length ? (
          <ManualTableStyles>
            <Table
              columns={manualcolumns}
              data={manualdata}
              itemName="Students"
              maxWidth="49.37rem"
              isSortedBy
            />
          </ManualTableStyles>
        ) : null}
        {(formShow && btnShow) || !addStudents?.length ? (
          <div>
            <div
              className="add-student-modal"
              style={{padding: '1.5rem 0rem 0rem 0rem'}}
            >
              <div className="add-student-modal-body">
                <form>
                  <div className="d-flex form-fields">
                    <div className="fields">
                      <Controller
                        control={control}
                        name="referId"
                        render={fields => (
                          <TextInput
                            {...fields}
                            errorMessage={
                              errors.referId?.message || formError.referId
                            }
                            autoFocus
                            hasError={!!errors.referId || !!formError.referId}
                            label="Reference ID"
                            placeholder="Enter Reference ID"
                            id="referId"
                          />
                        )}
                      />
                    </div>
                    <div className="fields">
                      <Controller
                        control={control}
                        name="firstName"
                        render={fields => (
                          <TextInput
                            {...fields}
                            errorMessage={errors?.firstName?.message}
                            hasError={!!errors.firstName}
                            label="First Name"
                            placeholder="Enter first name"
                            id="firstName"
                          />
                        )}
                      />
                    </div>
                    <div className="field-last">
                      <Controller
                        control={control}
                        name="lastName"
                        render={fields => (
                          <TextInput
                            {...fields}
                            errorMessage={errors?.lastName?.message}
                            hasError={!!errors.lastName}
                            label="Last Name"
                            placeholder="Enter last name"
                            id="lastName"
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="d-flex pb-4">
                    <Controller
                      control={control}
                      name="email"
                      render={fields => (
                        <TextInput
                          {...fields}
                          errorMessage={
                            errors.email?.message || formError.email
                          }
                          hasError={!!errors.email || !!formError.email}
                          label="Email"
                          placeholder="Enter email address"
                          id="emailId"
                        />
                      )}
                    />
                  </div>
                </form>
              </div>
            </div>

            <div
              className="button-container"
              style={{padding: '0rem 0rem 1.5rem 0rem'}}
            >
              {addStudents?.length && formShow ? (
                <CustomCancel
                  className="cancel"
                  bgColor="#fff"
                  id="addStudentCancelbtn"
                  onClick={() => {
                    reset();
                    setFormShow(false);
                    setBtnShow(false);
                  }}
                >
                  <span className="cancel-button-text">Cancel</span>
                </CustomCancel>
              ) : null}

              <CustomCancel
                className="save-changes"
                bgColor="#fff"
                id="addStudentbtn"
                padding="0.562rem 0.875rem"
                onClick={handleSubmit(onSubmit)}
              >
                <img src={AddIcon} alt="icon" style={{marginRight: '0.5rem'}} />
                <span className="add-button-text">
                  {addStudents.length > 0 ? 'Add to list' : 'Add Student'}
                </span>
              </CustomCancel>
            </div>
          </div>
        ) : (
          <div
            className="button-container"
            style={{padding: '1.5rem 0 1.5rem 0rem'}}
          >
            <CustomCancel
              className="save-changes"
              bgColor="#fff"
              id="addAnotherStudent"
              padding="0.562rem 0.875rem"
              onClick={() => {
                setFormShow(true);
                setBtnShow(true);
              }}
            >
              <img src={AddIcon} alt="icon" style={{marginRight: '0.5rem'}} />
              <span className="add-button-text">Add another Student</span>
            </CustomCancel>
          </div>
        )}
      </div>
    </FormContainer>
  );
};
